





















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import StorePersetujuanTransfusiDarah from "@/store/modules/PersetujuanTransfusiDarah";
import SvcPersetujuanTransfusiDarah from "@/services/PersetujuanTransfusiDarah";
import BaseCardSuketMultiple from "@/components/pemeriksaan/resumeSuketV2/BaseCardSuketMultiple.vue";
import BerkasPersetujuanDarah from "./BerkasPersetujuanDarah.vue";
import PersetujuanTransfusiDarahInputCard from "./PersetujuanTransfusiDarahInputCard.vue";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: {
    BerkasPersetujuanDarah,
    BaseCardSuketMultiple,
    PersetujuanTransfusiDarahInputCard
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PersetujuanTransfusiDarahTabPage extends Vue {
  @Prop() readonly register!: string;

  @Prop({ type: Boolean, default: false }) readonly sembunyikanTambah!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  expandInput = false;
  pageTab = "tab-soap";
  dataSuketActive: any = null;

  checklistItems = [
    { key: "tujuan_indikasi", label: "Tujuan / Indikasi tindakan transfusi darah" },
    { key: "jenis_komponen", label: "Jenis komponen dan perkiraan jumlah darah yang diberikan" },
    { key: "risiko_komplikasi", label: "Risiko dan komplikasi yang mungkin terjadi (termasuk resiko infeksi HIV, Hepatitis B, Hepatitis C, Virus Hepatitis lainnya, Sifilis, Malaria, dan penyakit lainnya)" },
    { key: "tindakan_luar_dugaan", label: "Tindakan lain yang diberikan jika dokter menemukan sesuatu yang diluar dugaan" },
    { key: "hasil_tidak_sesuai", label: "Tindakan ini bisa memberikan hasil yang tidak sesuai harapan meskipun sudah dilakukan sesuai prosedur yang berlaku" },
    { key: "kondisi_darurat", label: "Dalam kondisi kritis/darurat (emergency) transfusi dapat diberikan tanpa menunggu hasil Cross Test darah" }
  ];

  hubunganOptions = [
    { value: "diri_sendiri", text: "Diri Sendiri" },
    { value: "istri", text: "Istri" },
    { value: "suami", text: "Suami" },
    { value: "anak", text: "Anak" },
    { value: "ibu", text: "Ibu" },
    { value: "ayah", text: "Ayah" }
  ];

  get dataSuket(): any[] {
    return StorePersetujuanTransfusiDarah.suket.map(item => ({
      ...item,
      dokter_id: item.signee_user_id,
      dokter: item.signee
    }));
  }

  get loadContent() {
    return StorePersetujuanTransfusiDarah.loading;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  getHubunganLabel(value: string) {
    const found = this.hubunganOptions.find(o => o.value === value);
    return found ? found.text : value || "-";
  }

  tglSurat(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  setActive(data) {
    this.dataSuketActive = data;
  }

  edit(data) {
    this.dataSuketActive = data;
    this.showInput();
  }

  add() {
    this.dataSuketActive = null;
    this.showInput();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SvcPersetujuanTransfusiDarah.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.dataSuketActive = null;
  }

  muatUlang() {
    StorePersetujuanTransfusiDarah.getSuketByRegister(this.register);
  }

  setJumlahBerkas(payload: { id: number; jumlah: number }) {
    StorePersetujuanTransfusiDarah.SET_SUKET(
      StorePersetujuanTransfusiDarah.suket.map(s => (s.id === payload.id ? { ...s, berkas_count: payload.jumlah } : s))
    );
  }

  remove(item) {
    SvcPersetujuanTransfusiDarah.destroy(item.id).then(dt => {
      if (dt.status == 1) {
        appModule.NoticeDelay("Berhasil Hapus Persetujuan Transfusi Darah");
        StorePersetujuanTransfusiDarah.getSuketByRegister(this.register);
      } else {
        appModule.sendErrorAlert(dt.message);
      }
    });
  }
}
